import WelcomeMessage from "./functional";
export default WelcomeMessage;
